import classNames from 'classnames'
import {SearchGroupIcon} from 'components/AppIcon'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import Pure from 'components/Pure'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useCallback, useContext} from 'react'
import {IoCalendarClearOutline} from 'react-icons/io5'
import {NavLink, Redirect, Route, Switch, useRouteMatch,} from 'react-router-dom'
import {withProps} from 'recompose'
import {staticPaths} from 'routes/staticPaths'
import {mapPathParam} from 'views/AppLocals/functions/routerHelper'
import {Queries} from 'views/Shared/enums/Queries'
import WorkspaceSubHeader from './WorkspaceSubHeader'
import useTranslate from "../../../modules/local/useTranslate";
import {Button} from "antd";
import {useLocation, useToggle} from "react-use";
import WorkspaceContext from "../WorkspaceContext";
import EmptyHolder from "../../../components/EmptyHolder";
import {HiOutlineLockClosed} from "react-icons/hi2";

const rootPath = staticPaths.workspace.pathname

const renderFeatureItem = (type, {url, label, disabled = false}) => {
    if (_.isEmpty(type)) return null

    const Component = !!disabled
        ? 'div'
        : withProps({
            to: url,
            activeClassName: 'menu-workspace-active',
        })(NavLink)

    return (
        <Translate key={type}>
            {(t) => (
                <Component
                    style={{
                        minWidth: '5.5rem',
                        width: '100%',
                        height: '5.5rem',
                    }}
                    className={classNames(
                        'flex flex-col flex-center gap-2 rounded-lg no-underline p-2 shadow hover:shadow-md ',
                        !!disabled && 'disable'
                    )}>
                    <SearchGroupIcon
                        type={type}
                        size={25}
                        FallbackComponent={IoCalendarClearOutline}
                    />
                    <span className="font-medium text-center text-xs tracking-wider">{t(label)}</span>
                </Component>
            )}
        </Translate>
    )
}

const WorkspaceFeatures = ({
                               routes = [],
                               defaultAction,
                               Wrapper = 'div',
                               actionField = Queries.ACTION,
                               isDisabled = (route) => false,
                           }) => {
    const t = useTranslate();
    const {path: root, ...restRoute} = useRouteMatch()
    const location = useLocation();
    const {isSm, isLg} = useContext(LayoutContext)
    const [isToggle, toggle] = useToggle(true)
    const {organization} = useContext(WorkspaceContext)

    const getPath = useCallback(
        (key) => {
            if (root.includes(actionField)) {
                return mapPathParam(root, {
                    [actionField]: key,
                })
            } else {
                return [root, key].join('/')
            }
        },
        [root, actionField]
    )
    const currentKey = location?.pathname?.split('/').filter(Boolean).pop();

    if (_.isEmpty(routes)) return null;

    return (
        <Wrapper className="space-y-3 container mx-auto">
            <div className="p-3 flex items-center gap-3 p-3">
                <div className="flex flex-1 font-bold text-2xl lg:text-3xl text-gray-800">
                    {t("workspace")}
                </div>
                <Button
                    color="default" variant="filled"
                    onClick={toggle}
                    className="rounded-lg no-shadow no-text-shadow text-color-200 truncate">
                    {isToggle ? t("show optional modules") : t("hide optional modules")}
                </Button>
            </div>
            <div className="p-3 my-3">
                <div className="grid grid-cols-3 md:grid-cols-10 gap-3">
                    <Pure input={[routes, isToggle, isDisabled]}>
                        {(isToggle ? routes.filter(e => !e?.isOptional || (e?.key === currentKey)) : routes)
                            .map(
                                ({key, isServiceDisable = () => false, label, ...route}) =>
                                    renderFeatureItem(key, {
                                        label,
                                        disabled: isDisabled(route) || isServiceDisable(organization),
                                        url: getPath(key),
                                    })
                            )}
                    </Pure>
                </div>

                {isSm && <WorkspaceSubHeader routes={routes}/>}
            </div>
            <Switch>
                <Route
                    exact={true}
                    path={rootPath}
                    render={() => <Redirect to={getPath(defaultAction)} push={false}/>}
                />
                {routes.map(({key, required_permissions, isServiceDisabled = (org) => false, ...route}) => {

                    return (
                        <Route
                            key={key}
                            exact={true}
                            path={getPath(key)}
                            {...route}
                            component={!isServiceDisabled(organization) ? route?.component : () => (
                                <EmptyHolder
                                    icon={() => (
                                        <HiOutlineLockClosed size={64} style={{ color: "#9ca3af" }} />
                                    )}
                                    title="feature not enabled"
                                    subTitle="please contact the system administrator to enable access to this feature."
                                >

                                </EmptyHolder>
                            )}
                        />
                    )
                })}
                <Route
                    path="*"
                    render={() => <Redirect to={getPath(defaultAction)} push={false}/>}
                />
            </Switch>
            <div/>
        </Wrapper>
    )
}

export default WorkspaceFeatures
